// Inline feather-style line icons + the 4-point sparkle for agent content.
// Paths lifted verbatim from the design reference so the chrome/nav match
// pixel-for-pixel. ponytail: a path map, not an icon library dependency.
import type { CSSProperties } from "react";

const PATHS: Record<string, string> = {
  home: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z|M9 22V12h6v10",
  activity: "M22 12h-4l-3 9L9 3l-3 9H2",
  "clipboard-list": "M4 3h16v18H4z|M9 3v3h6V3M8 11h8M8 15h5",
  grid: "M3 3h7v7H3z|M14 3h7v7h-7z|M14 14h7v7h-7z|M3 14h7v7H3z",
  book: "M3 4h18v16H3z|M7 9h5M7 13h8M7 17h6",
  layers: "M12 2l9 5-9 5-9-5z|M3 12l9 5 9-5M3 17l9 5 9-5",
  folder: "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
  dollar: "M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6",
  atlas: "M6 6m-2.4 0a2.4 2.4 0 1 0 4.8 0a2.4 2.4 0 1 0-4.8 0|M18 18m-2.4 0a2.4 2.4 0 1 0 4.8 0a2.4 2.4 0 1 0-4.8 0|M6 8.5V15a3 3 0 0 0 3 3h6",
  "clipboard-check": "M4 3h16v18H4z|M9 3v3h6V3M8 12l2 2 4-4",
  users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2|M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0-8 0|M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  settings:
    "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0-6 0|M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-2.7 1.1V21a2 2 0 0 1-4 0v-.1A1.6 1.6 0 0 0 7 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0-1.1-2.7H1a2 2 0 0 1 0-4h.1A1.6 1.6 0 0 0 2.6 7a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 2.7-1.1V1a2 2 0 0 1 4 0v.1A1.6 1.6 0 0 0 17 2.6a1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0 1.1 2.7h.2a2 2 0 0 1 0 4h-.1a1.6 1.6 0 0 0-1.4 1.1z",
  plug: "M9 2v6M15 2v6M6 8h12v3a6 6 0 0 1-12 0z|M12 17v5",
  shield: "M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z",
  "shield-check": "M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z|M9 12l2 2 4-4",
  help: "M12 12m-10 0a10 10 0 1 0 20 0a10 10 0 1 0-20 0|M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3M12 17h.01",
  logout: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  clock: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0-18 0|M12 7v5l3 2",
  calendar: "M4 4h18v16H4z|M8 2v4M16 2v4M3 10h18",
  send: "M22 2L11 13M22 2l-7 20-4-9-9-4z",
  close: "M18 6L6 18M6 6l12 12",
  refresh: "M23 4v6h-6M1 20v-6h6|M3.5 9a9 9 0 0 1 15-3.4L23 10M1 14l4.5 4.4A9 9 0 0 0 20.5 15",
  edit: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7|M18.5 2.5a2.1 2.1 0 0 1 3 3L12 15l-4 1 1-4z",
  trash: "M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6",
  upload: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
  "folder-plus": "M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z|M12 11v5M9.5 13.5h5",
  check: "M20 6L9 17l-5-5",
  search: "M11 11m-7 0a7 7 0 1 0 14 0a7 7 0 1 0-14 0|M21 21l-4.3-4.3",
  "map-pin": "M12 21s-7-6-7-11a7 7 0 0 1 14 0c0 5-7 11-7 11z|M12 10m-2.4 0a2.4 2.4 0 1 0 4.8 0a2.4 2.4 0 1 0-4.8 0",
  chart: "M3 17l6-6 4 4 7-7|M17 8h4v4",
  hex: "M12 2l9 5v10l-9 5-9-5V7z",
  "arrow-right": "M5 12h14M13 6l6 6-6 6",
  "arrow-left": "M19 12H5M12 19l-7-7 7-7",
  download: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3",
  "check-square": "M9 11l3 3L22 4|M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11",
  square: "M3 3h18v18H3z",
  "square-check": "M9 11l3 3L22 4|M3 3h18v18H3z",
  warning: "M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z|M12 9v4M12 17h.01",
  info: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0-18 0|M12 11v5M12 7.5h.01",
  plus: "M12 5v14M5 12h14",
  "chevron-down": "M6 9l6 6 6-6",
  "chevron-up": "M18 15l-6-6-6 6",
  "chevron-left": "M15 18l-6-6 6-6",
  "chevron-right": "M9 18l6-6-6-6",
  sparkles: "M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z|M19 13l.8 2.2L22 16l-2.2.8L19 19l-.8-2.2L16 16l2.2-.8z",
  template: "M4 4h7v7H4z|M13 4h7v4h-7z|M13 10h7v10h-7z|M4 13h7v7H4z",
  "file-import": "M14 3v4a1 1 0 0 0 1 1h4|M5 13v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9l-5-5H7a2 2 0 0 0-2 2v4|M9 15l3-3 3 3M12 12v6",
  star: "M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.4-5.8-3-5.8 3 1.1-6.4L2.6 9.4l6.5-.9z",
  "external-link": "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6|M15 3h6v6|M10 14L21 3",
  "message-circle": "M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z",
};

export function Icon({
  name,
  size = 17,
  stroke = 1.7,
  fill = "none",
  style,
}: {
  name: string;
  size?: number;
  stroke?: number;
  /** "currentColor" to render a solid glyph (e.g. a starred/on state). */
  fill?: string;
  style?: CSSProperties;
}) {
  const d = PATHS[name] ?? "";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      {d.split("|").map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}

/** The 4-point sparkle — the one consistent "AI-derived" mark (filled). */
export function Sparkle({ size = 14, style }: { size?: number; style?: CSSProperties }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" style={style}>
      <path d="M12 2l2.1 6.9L21 11l-6.9 2.1L12 20l-2.1-6.9L3 11l6.9-2.1z" />
    </svg>
  );
}
